import AppletSecurityError from '../../Error/AppletSecurityError';
import ErrorCodes from '../../../FrontApplet/Error/ErrorCodes';
import ErrorSuggestions from '../../../FrontApplet/Error/ErrorSuggestions';

export function generateRandomPin() {
	return Math.floor(Math.random() * 1e4)
		.toString()
		.padStart(4, '0');
}

export function validatePinCode(pinCode: string) {
	if (!pinCode.match(/^\d{4}$/)) {
		throw new AppletSecurityError({
			kind: 'appletSecurityError',
			message: `Invalid PIN code: ${pinCode}`,
			code: ErrorCodes.SECURITY_PIN_CODE_INVALID,
			suggestion: ErrorSuggestions.SECURITY_PIN_CODE_FORMAT,
		});
	}
}
